// Module
var code = "<template class=\"ess-validate\"> <form submit.trigger=\"handleSubmit()\" keydown.delegate=\"handleKeyDown($event)\" ess-loading.bind=\"state.saving\" element.ref=\"form\"> <ess-icon-required-info if.bind=\"showRequiredFieldsMessage\"></ess-icon-required-info> <slot></slot> <input type=\"submit\" class=\"hide\"/> </form> </template> ";
// Exports
module.exports = code;